<template>
  <div class="bubble flex items-center justify-center w-16 h-6 rounded-md opacity-40">
    <div class="message message--loading">
      <div class="message__bubble">
        <div class="message__loading-indicator"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Loading extends Vue {}
</script>

<style scoped>
.bubble .message {
  display: flex;
  align-items: center;
  transform-origin: left;
}

.message .message__loading-indicator,
.message .message__loading-indicator:before,
.message .message__loading-indicator:after {
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  animation-name: indicator;
  animation-duration: 0.8s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
  content: '';
}

.message .message__loading-indicator {
  margin-right: 20px;
}

.message .message__loading-indicator:before,
.message .message__loading-indicator:after {
  position: absolute;
}

.message .message__loading-indicator:before {
  transform: translateX(180%);
  animation-delay: 0.125s;
}

.message .message__loading-indicator:after {
  transform: translateX(360%);
  animation-delay: 0.25s;
}
</style>
